import * as React from 'react';
import clsx from 'clsx';

import { FormParserContext } from 'src/contexts/form.context';
import { render } from 'src/tools/render.tools';
import { Radio } from 'src/components/Radio';
import { ButtonBaseType, ID } from 'src/models/general.model';

import classes from './RadioList.module.scss';

export function RadioList() {
  const { value, script, onChange } = React.useContext(FormParserContext);

  const { customization = 'row' } = script;

  function handleOnChange(id: ID) {
    return function call() {
      onChange(id);
    };
  }

  function renderRadio(item: ButtonBaseType) {
    return (
      <Radio
        key={item.id}
        value={String(item.id)}
        label={item.label}
        isChecked={(value ?? script.defaultValue) === item.id}
        onClick={handleOnChange(item.id)}
      />
    );
  }

  return <div className={clsx('row', classes[customization])}>{render(script.items ?? [], renderRadio)}</div>;
}
